// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"0ca02584","537":"e64154bf","850":"3d9db72b"}[chunkId] + ".chunk.css";
};